var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('div',{staticClass:"faqTitleLine"},[_c('p',[_vm._v(_vm._s(_vm.item.title))]),_c('div',{staticClass:"pointerFaqItem",class:{active:_vm.openItem},on:{"click":_vm.toogleDesc}},[_c('div'),_c('div')])]),_c('div',{staticClass:"faqDesc",class:{active:_vm.openItem},domProps:{"innerHTML":_vm._s(_vm.item.desc)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }